export default __webpack_public_path__ + "static/media/PORTFOLIOSITE.65549d30.mp4";